<div class="closeButton" >
    <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div id="loginCard">
    <mat-card align="center"  class="loginMatCard">
        <h1 mat-dialog-title>{{'keyword_$434' | translate}} {{data.user_name}} </h1>
        <div mat-dialog-content>
           {{'keyword_$430' | translate}}
           <br>
           {{'keyword_$431' | translate}}
           <br>
           <br>
        </div>
        <form class="" [formGroup]="deleteFormGroup" >
            <mat-form-field appearance="fill">
                <input autocomplete="off"
                name="delete"
                id="delete"
                required
                #delete
                color="primary"
                formControlName="delete"
                matInput placeholder="DELETE">
            </mat-form-field>
            <div mat-dialog-actions align="center">
              <button mat-button class="requestButton" (click)="onNoClick()">{{'keyword_$228' | translate}}</button>
              <button mat-button class="requestButtonClose" [disabled]="delete.value != 'DELETE'" color="warn" (click)="deleteUser(data.user_id, data.user_email, data.user_name)" >{{'keyword_$1' | translate}}</button>
            </div>
        </form>
    </mat-card>
</div>
